import './styles.scss';

import React from 'react';
import { render } from 'react-dom';

import CalcWidget from './CalcWidget';

// Mount on every `[data-calc-widget]` element. Server emits the
// mount-div with a sibling `<script type="application/json">` carrying
// the `calculatorOptions` payload — co-rendered so the bundle never
// has to decode HTML entities from a `data-config` attribute.

const VARIANTS = ['hero', 'footer', 'sidebar'];

function readConfig(variant) {
    const node = document.getElementById(`calc-widget-config-${variant}`);
    if (!node) return null;
    try {
        return JSON.parse(node.textContent || '{}');
    } catch (e) {
        return {};
    }
}

function mount() {
    VARIANTS.forEach((variant) => {
        const host = document.getElementById(`calc-widget-${variant}`);
        if (!host) return;
        const config = readConfig(variant) || {};
        render(<CalcWidget config={config} variant={variant} />, host);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
} else {
    mount();
}
